import Vue from "vue";
import Router from "vue-router";
// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}


//所有权限通用路由表
//如首页和登录页和一些不用权限的公用页面
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/error/401",
    component: () => import("@/views/error/401"),
    hidden: true
  },
  {
    path: "/error/404",
    component: () => import("@/views/error/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    name: "",
    // hidden: true,
    children: [
      {
        path: "/",
        name: "Dashboard",
        meta: { title: "首页", icon: "dashboard", affix: true },
        component: () => import("@/views/dashboard/index")
      }
    ]
  },
  {
    path: "",
    component: Layout,
    name: "Info",
    hidden: true,
    children: [
      {
        path: "/info",
        component: () => import("@/views/info/index")
      }
    ]
  },
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  {
    path: "/upload",
    name: "Upload",
    component: () => import("@/views/upload/index"),
    hidden: true,
  },
];

//实例化vue的时候只挂载constantRouter
export default new Router({
  mode: "history",
  routes: constantRouterMap
});

//异步挂载的路由
//动态需要根据权限加载的路由表
//meta无permissions字段则不做权限控制
export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "User",
    meta: { title: "用户管理", permissions: ["admin"], icon: "users" },
    children: [
      {
        path: "/user/list",
        name: "Users",
        component: () => import("@/views/user/index"),
        meta: { title: "用户列表", permissions: ["admin"] },
      },
      {
        path: "/user/distribution",
        name: "Distribution",
        hidden: true,
        component: () => import("@/views/user/distribution"),
        meta: { title: "分销", permissions: ["admin"] }
      },
      {
        path: "/user/certification",
        name: "Certification",
        component: () => import("@/views/user/certification"),
        meta: { title: "实名认证", permissions: ["admin"] },
      }
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "System",
    meta: { title: "套餐管理", permissions: ["admin", "role"], icon: "system" },
    children: [
      {
        path: "/product/category",
        name: "ProductCategory",
        component: () => import("@/views/product/type"),
        meta: { title: "套餐分类", permissions: ["admin"] }
      },
      {
        path: "/destination",
        name: "Destination",
        component: () => import("@/views/product/type"),
        meta: { title: "目的地", permissions: ["admin"] }
      },
      {
        path: "/product/list",
        name: "productList",
        component: () => import("@/views/product/productList"),
        meta: { title: "套餐&路线", permissions: ["admin"] }
      },
      {
        path: "/product/store",
        name: "ProductStore",
        hidden:true,
        component: () => import("@/views/product/store"),
        meta: { title: "套餐新增修改", permissions: ["admin"], keepAlive: true }
      }
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Shop",
    meta: {
      title: "供应商管理",
      permissions: ["admin"],
      icon: "content"
    },
    children: [
      {
        path: "/shopList",
        name: "ShopList",
        component: () => import("@/views/shop/index"),
        meta: { title: "供应商列表", permissions: ["admin"] }
      },
      {
        path: "/shopStore",
        name: "ShopStore",
        hidden:true,
        component: () => import("@/views/shop/shopStore"),
        meta: { title: "供应商新增修改", permissions: ["admin"] }
      }
    ]
  },

  {
    path: "",
    component: Layout,
    alwaysShow: true,
    name: "Order",
    meta: {
      title: "订单管理",
      permissions: ["admin"],
      icon: "content"
    },
    children: [
      {
        path: "/orderList",
        name: "OrderList",
        component: () => import("@/views/order/index"),
        meta: { title: "订单列表", permissions: ["admin"] }
      },
      {
        path: "/order/viewDetails",
        name: "viewDetails",
        hidden:true,
        component: () => import("@/views/order/viewDetails"),
        meta: { title: "查看详情", permissions: ["admin"] }
      },
      {
        path: "/order/checkAfterSales",
        name: "checkAfterSales",
        hidden:true,
        component: () => import("@/views/order/checkAfterSales"),
        meta: { title: "查看售后", permissions: ["admin"] }
      },
      {
        path: "/subscribeList",
        name: "SubscribeList",
        component: () => import("@/views/order/subscribeList"),
        meta: { title: "预约列表", permissions: ["admin"] }
      }

    ]
  },
  // {
  //   path: '',
  //   component: Layout,
  //   alwaysShow: true,
  //   name: 'live',
  //   meta: { title: '直播管理', permissions: ['admin'], icon: 'tree' },
  //   children: [
  //     {
  //       path: '/live/index',
  //       name: 'index',
  //       component: () => import('@/views/live/index'),
  //       meta: { title: '直播列表' }
  //     },
  //   ]
  // },
  {
    path: "/finance",
    name: "finance",
    component: Layout,
    alwaysShow: true,
    redirect: "/finance/index",
    meta: { title: "财务管理", icon: "example" },
    children: [{
      path: "index",
      name: "financeList",
      component: () => import("@/views/finance/index"),
      meta: { title: "财务统计" }
    },
    {
      path: "shopWithdraw",
      name: "shopWithdraw",
      component: () => import("@/views/finance/shopWithdraw"),
      meta: { title: "店铺提现" }
    },
    {
      path: "schoolFin",
      name: "schoolFin",
      component: () => import("@/views/finance/schoolFin"),
      meta: { title: "店铺财务" }
    },
    {
      path: "flowingWater",
      name: "flowingWater",
      hidden:true,
      component: () => import("@/views/finance/flowingWater"),
      meta: { title: "流水" }
    },
    // {
    //   path: "partServant",
    //   name: "partServant",
    //   component: () => import("@/views/finance/partServant"),
    //   meta: { title: "分佣设置" }
    // },
    {
      path: "withdraw",
      name: "withdraw",
      component: () => import("@/views/finance/withdraw"),
      meta: { title: "用户提现记录" }
    },
    {
      path: "userRecharge",
      name: "userRecharge",
      component: () => import("@/views/finance/userRecharge"),
      meta: { title: "用户充值记录" }
    },
    {
      path: "cashout",
      name: "cashout",
      hidden: true,
      component: () => import("@/views/finance/cashout"),
      meta: { title: "提现" }
    },
    ]
  },
  {
    path: "/website",
    name: "website",
    component: Layout,
    alwaysShow: true,
    redirect: "/website/userAgreenment",
    meta: { title: "建站管理", icon: "link" },
    children: [
      {
        path: "userAgreement",
        name: "userAgreement",
        component: () => import("@/views/website/userAgreement"),
        meta: { title: "用户使用协议" }
      },
      {
        path: "userPurchaseAgreement",
        name: "userPurchaseAgreement",
        component: () => import("@/views/website/userPurchaseAgreement"),
        meta: { title: "用户购买协议" }
      },
      {
        path: "userPrivacyProtocol",
        name: "userPrivacyProtocol",
        component: () => import("@/views/website/userPrivacyProtocol"),
        meta: { title: "用户隐私协议" }
      },
      {
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/website/feedback"),
        meta: { title: "用户反馈" }
      },
      {
        path: "aboutUs",
        name: "aboutUs",
        component: () => import("@/views/website/aboutUs"),
        meta: { title: "公司介绍" }
      },
      {
        path: "memberPrivileges",
        name: "memberPrivileges",
        component: () => import("@/views/website/memberPrivileges"),
        meta: { title: "会员特权说明" }
      },
      {
        path: "cooperation",
        name: "cooperation",
        component: () => import("@/views/website/cooperation"),
        meta: { title: "申请合作" }
      },
      // {
      //   path: "companyMessage",
      //   name: "companyMessage",
      //   component: () => import("@/views/website/companyMessage"),
      //   meta: { title: "公司介绍" }
      // },
      // {
      //   path: "liveAgreement",
      //   name: "liveAgreement",
      //   component: () => import("@/views/website/liveAgreement"),
      //   meta: { title: "购买协议" }
      // },
      // {
      //   path: "cashOut",
      //   name: "cashOut",
      //   component: () => import("@/views/website/cashOut"),
      //   meta: { title: "提现协议" }
      // }
    ]
  },
  {
    path: "/operate",
    name: "operate",
    component: Layout,
    alwaysShow: true,
    meta: { title: "运营管理", icon: "nested" },
    children: [
      {
        path: "generalSettings",
        name: "generalSettings",
        component: () => import("@/views/operate/generalSettings"),
        meta: { title: "通用设置" }
      },
      // {
      //   path: "orderPlacement",
      //   name: "orderPlacement",
      //   component: () => import("@/views/operate/orderPlacement"),
      //   meta: { title: "下订单设置" }
      // },
      // 用户行为数据
      {
        path: "banana",
        name: "banana",
        component: () => import("@/views/operate/banana"),
        meta: { title: "轮播图管理" }
      },
      // {
      //   path: "themePhoto",
      //   name: "themePhoto",
      //   component: () => import("@/views/operate/themePhoto"),
      //   meta: { title: "主题图片管理" }
      // },
      {
        path: "couponList",
        name: "couponList",
        component: () => import("@/views/operate/couponList"),
        meta: { title: "优惠券列表" }
      },
      {
        path: "useCouponRecord",
        name: "useCouponRecord",
        hidden: true,
        component: () => import("@/views/operate/useCouponRecord"),
        meta: { title: "优惠券使用记录" }
      },
      {
        path: "receive",
        name: "receive",
        hidden: true,
        component: () => import("@/views/operate/receive"),
        meta: { title: "领取人列表" }
      },
      {
        path: "canReceiveList",
        name: "canReceiveList",
        hidden: true,
        component: () => import("@/views/operate/canReceiveList"),
        meta: { title: "赠送优惠券" }
      },
    ]
  },
  { path: "*", redirect: "/error/404", hidden: true }
];
